import React, { useContext, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { LanguageContext } from "../LanguageContext";

import * as timeToolbox from "../ressources/tools/utils";
import {
  CO2Response,
  ConseilResponse,
  ConsoResponseWithYearlyAverage,
  Debit,
  MedianeResponse,
  ObjectifResponse,
} from "../typings/types";
import "./CapteurDetails.css";
// Components
import LoaderIcon from "../ressources/tools/LoaderIcon";
import Header from "../views/Header/Header";
import CO2 from "./CO2/CO2";
import Conseil from "./Conseil/Conseil";
import Consommation from "./Consommation/Consommation";
import Objectif from "./Objectif/Objectif";

// Images
import img_CO2 from "../ressources/images/CO2.svg";
import img_conseil from "../ressources/images/conseil.svg";
import img_consommation from "../ressources/images/consommation.svg";
import img_objectif from "../ressources/images/objectif.svg";
import {
  getCO2,
  getConseil,
  getConsommation,
  getMediane,
  getObjectif,
} from "../ressources/tools/service";
import { getFrequenceAndStartAndEndInterval } from "../ressources/tools/utils";

function CapteurDetails() {
  const { translations } = useContext(LanguageContext);
  const location = useLocation();

  const { id } = useParams(); // Cela extrait l'ID de l'URL
  const [sendReqMedianeMax, setSendReqMedianeMax] = useState(true);
  const [sendReqOnglet, setSendReqOnglet] = useState(true);

  const [medianeResponse, setMedianeResponse] = useState<
    MedianeResponse | undefined
  >(undefined);
  const [co2, setCo2] = useState<CO2Response | undefined>(undefined);
  const [consommation, setConsommation] = useState<
    ConsoResponseWithYearlyAverage | undefined
  >(undefined);
  const [objectif, setObjectif] = useState<ObjectifResponse | undefined>(
    undefined
  );
  const [conseil, setConseil] = useState<ConseilResponse | undefined>(
    undefined
  );

  const [frequence, setFrequence] = useState<number>(0);
  const [indexSensor, setIndexSensor] = useState<number | undefined>(undefined);
  const [type_id, setType_id] = useState<number>(0);
  const [sensor_id, setSensor_id] = useState<number>(0);
  const [sensor_name, setSensor_name] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [erreurReq, setErreurReq] = useState<boolean>(false);

  const [carburant, setCarburant] = useState(() => {
    // Recupera o carburante salvo no localStorage, se existir
    const savedCarburant = localStorage.getItem("selectedCarburant");
    return savedCarburant ? savedCarburant : "gazole";
  });

  const ongletsGeneral = [
    { name: "CO2", icon: { src: img_CO2, alt: translations["icon de CO2"] } },
    {
      name: "consommation",
      icon: {
        src: img_consommation,
        alt: translations["icon de consommation"],
      },
    },
    {
      name: "objectif",
      icon: { src: img_objectif, alt: translations["icon de objectif"] },
    },
    {
      name: "conseil",
      icon: { src: img_conseil, alt: translations["icon de conseil"] },
    },
  ];

  // Carburant selector
  useEffect(() => {
    // Sempre que o carburante mudar, salva no localStorage
    localStorage.setItem("selectedCarburant", carburant);
  }, [carburant]);

  useEffect(() => {
    const path = location.pathname;
    const parts = path.split("/");
    const ids = parts[parts.length - 1].split("_");

    if (ids.length >= 2) {
      const typeId = parseInt(ids[0]);
      const sensorId = parseInt(ids[1]);
      setType_id(typeId);
      setSensor_id(sensorId);
      setSensor_name(ids.length > 2 ? ids[2] : `${typeId}-${sensorId}`);
    } else {
      console.error("A URL não contém as informações esperadas.");
    }
  }, [location.pathname]);

  useEffect(() => {
    if (type_id) {
      setSendReqMedianeMax(true);
      setSendReqOnglet(true);
    }
  }, [type_id]);

  const date_auj_00_00 = timeToolbox.getCurrentDateAtMidnightUTC();

  const envoieReqApresErreur = () => {
    setErreurReq(false);
    setSendReqOnglet(true);
  };
  const [ongletFrequence, setOngletFrequence] = useState<number>(() => {
    const storedFrequence = localStorage.getItem("ongletFrequence");
    return storedFrequence !== null ? parseInt(storedFrequence, 10) : 0;
  });
  useEffect(() => {
    localStorage.setItem("ongletFrequence", "" + ongletFrequence);
  }, [ongletFrequence]);

  const changementDOngletFrequence = (ongletFrequenceSelectionne: number) => {
    setOngletFrequence(ongletFrequenceSelectionne);
    setSendReqOnglet(true);
    setErreurReq(false);
  };

  const [activeTab, setActiveTab] = useState(() => {
    const storedTab = localStorage.getItem("activeTab");
    return storedTab &&
      ongletsGeneral.some((onglet) => onglet.name === storedTab)
      ? storedTab
      : ongletsGeneral[0].name;
  });

  useEffect(() => {
    // Sempre que activeTab mudar, atualize no localStorage
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  const changementDOngletGeneral = (tabName: string) => {
    setActiveTab(tabName);
    setSendReqOnglet(true);
    setErreurReq(false);
  };

  useEffect(() => {
    const time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (type_id && sendReqMedianeMax) {
      setLoading(true);
      const storageKey = `medianeMax_${type_id}_${time_zone}`;
      getMediane(type_id)
        .then((res) => {
          if (
            res.state &&
            res.mediane_debit !== undefined &&
            res.max_debit !== undefined
          ) {
            const expirationTime = Date.now() + 24 * 60 * 60 * 1000; // Expira em 24 horas
            localStorage.setItem(
              storageKey,
              JSON.stringify({
                ...res,
                date_median_max: date_auj_00_00,
                expirationTime,
              })
            );
            setMedianeResponse(res);
          } else {
            console.warn("Dados inválidos recebidos.");
            // Decida se mantém os dados antigos ou informa ao usuário
          }
        })
        .catch((error) => {
          console.error("Erro na requisição:", error);
          // Talvez manter os dados existentes e informar ao usuário
        })
        .finally(() => {
          setSendReqMedianeMax(false);
          setLoading(false);
        });
    }
  }, [type_id, sendReqMedianeMax, date_auj_00_00]);

  useEffect(() => {
    const getData = async () => {
      const requestInfo: {
        frequence: number;
        start_interval: number;
        end_interval: number;
      } = getFrequenceAndStartAndEndInterval(ongletFrequence, activeTab);

      setFrequence(requestInfo.frequence);

      setLoading(true);
      try {
        switch (activeTab) {
          case ongletsGeneral[0].name: {
            // CO₂
            const response = await getCO2(type_id, requestInfo);
            if (response.state) {
              const sensorIndex = response.debits_list.findIndex(
                (item: Debit) => item.sensor_id === sensor_id
              );
              setIndexSensor(sensorIndex !== -1 ? sensorIndex : undefined);
              const debitWithtoutEmpty = response.debits_list.filter(
                (a) => a.adjustedDebit !== 0
              );
              setCo2({ ...response, debits_list: debitWithtoutEmpty });
            } else {
              setErreurReq(true);
            }
            break;
          }
          case ongletsGeneral[1].name: {
            // Consommation
            const response = await getConsommation(sensor_id, requestInfo);
            const requestInfoForYear = getFrequenceAndStartAndEndInterval(
              3,
              activeTab
            );
            const responseForYear = await getConsommation(
              sensor_id,
              requestInfoForYear
            );
            if (response.state && responseForYear.state) {
              response.yearlyAverage =
                responseForYear.x.reduce((a, b) => a + b, 0) /
                responseForYear.x.length;
              setConsommation(response);
            } else {
              setErreurReq(true);
            }

            break;
          }
          case ongletsGeneral[2].name: {
            // Objectif
            const response = await getObjectif(sensor_id, requestInfo);
            response.state ? setObjectif(response) : setErreurReq(true);
            break;
          }
          case ongletsGeneral[3].name: {
            // Conseil
            const response = await getConseil(sensor_id, requestInfo);
            response.state ? setConseil(response) : setErreurReq(true);
            break;
          }
          default: {
            break;
          }
        }
      } catch (error: any) {
        console.error(error);
        setErreurReq(true);
      } finally {
        setSendReqOnglet(false);
        setLoading(false);
      }
    };

    if (!erreurReq && (type_id || sensor_id) && sendReqOnglet) {
      getData();
    }
  }, [
    type_id,
    sensor_id,
    sendReqOnglet,
    activeTab,
    ongletFrequence,
    erreurReq,
  ]);

  const displayIcons = () => {
    return ongletsGeneral.map((tab) => (
      <button
        key={tab.name}
        onClick={() => changementDOngletGeneral(tab.name)}
        className={
          tab.name === activeTab ? "tool-button active" : "tool-button"
        }
        aria-label={`${tab.name}-button`}
      >
        <img className={"icon-onglet"} src={tab.icon.src} alt={tab.icon.alt} />
      </button>
    ));
  };

  const errorButton = (
    <button className="btnMsg" onClick={() => setSendReqMedianeMax(true)}>
      Pas de données enregistrées pour cette période. Essayez une autre plage de
      dates !
    </button>
  );

  const renderTabContent = () => {
    if (erreurReq) {
      return (
        <button className="btnMsg" onClick={envoieReqApresErreur}>
          Pas de données enregistrées pour cette période. Essayez une autre
          plage de dates !
        </button>
      );
    } else {
      switch (activeTab) {
        case ongletsGeneral[0].name:
          if (
            !medianeResponse?.mediane_debit ||
            !medianeResponse?.max_debit ||
            !co2?.debits_list ||
            co2.debits_list.length === 0
          ) {
            console.error(
              "no mediane_debit || max_debit || debits_list || debits_list.length === 0"
            );
            return errorButton;
          }
          if (
            (!indexSensor && indexSensor !== 0) ||
            co2.debits_list.length <= 1
          ) {
            if (co2.debits_list.length === 1) {
              return (
                <button
                  className="btnMsg"
                  onClick={() => setSendReqMedianeMax(true)}
                >
                  Il s'agit de la seule machine pour laquelle nous disposons de
                  données remontées aujourd'hui. Par conséquent, nous ne pouvons
                  pas la comparer aux autres machines du même type. Veuillez
                  sélectionner une autre plage de dates.
                </button>
              );
            }
            console.error("no indexSensor");
            return errorButton;
          }
          return (
            <CO2
              mediane={medianeResponse?.mediane_debit}
              data={co2.debits_list}
              indexSensor={indexSensor}
              carburant={carburant}
              setCarburant={setCarburant}
              engineeringUnitCO2={medianeResponse?.engineering_unit}
            />
          );
        case ongletsGeneral[1].name:
          if (!medianeResponse?.max_debit) {
            console.error("no max_debit");
            return errorButton;
          }
          if (
            !(consommation?.t && consommation.t.length > 0) ||
            !(consommation?.x && consommation.x.length > 0) ||
            !frequence
          ) {
            console.error("no t_x");
            return errorButton;
          }
          return (
            <Consommation
              consommation={consommation}
              uniteTemps={frequence}
              carburant={"gazole"}
              maxDebit={medianeResponse?.max_debit}
            />
          );
        case ongletsGeneral[2].name:
          if (!objectif?.mediane_litres || !objectif?.cumul_litres_travail) {
            console.error("no mediane_litres");
            return errorButton;
          } else {
            return (
              <Objectif
                medianeLitres={objectif.mediane_litres}
                cumulLitresTravail={objectif.cumul_litres_travail}
                carburant={"gazole"}
              />
            );
          }
        case ongletsGeneral[3].name:
          if (!medianeResponse?.max_debit) {
            console.error("no max_debit");
            return errorButton;
          }
          if (
            isNaN(conseil?.seuil_ralenti!) ||
            isNaN(conseil?.debit_fonctionnement!) ||
            isNaN(conseil?.debit_ralenti!) ||
            isNaN(conseil?.temps_travail!) ||
            isNaN(conseil?.temps_ralenti!)
          ) {
            console.error(
              "no seuil_ralenti || debit_fonctionnement || debit_ralenti || temps_travail || temps_ralenti"
            );
            return (
              <button className="btnMsg" onClick={() => setSendReqOnglet(true)}>
                Pas de données enregistrées pour cette période. Essayez une
                autre plage de dates !
              </button>
            );
          }
          return <Conseil conseil={conseil!} />;
        default:
          return <div className="tab-content">Contenu de Consignes</div>;
      }
    }
  };
  return (
    <div className="valve-details">
      <Header
        activeTab={activeTab}
        changementDOngletFrequence={changementDOngletFrequence}
        titre={
          id ? (
            decodeURIComponent(sensor_name)
          ) : (
            <span>
              {translations["Chargement en cours"]}
              <LoaderIcon />
            </span>
          )
        }
        ongletFrequence={ongletFrequence}
      />
      {loading ? (
        <div className="loading-container">
          {translations["Chargement en cours"]}
          <LoaderIcon />
        </div>
      ) : (
        renderTabContent()
      )}
      <div className="footer">{displayIcons()}</div>
    </div>
  );
}

export default CapteurDetails;
